 <template>
  <div class="p-6 max-w-4xl mx-auto">
    <!-- Header con gradiente moderno -->
     <div class="flex justify-start mb-3">
        <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">
        &lt;UploadLibroMayor&gt;
      </span>
    </div>
    <div class="relative overflow-hidden rounded-2xl bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 p-8 mb-8 shadow-xl">
      <div class="absolute inset-0 bg-white/10 backdrop-blur-sm"></div>
      <div class="relative z-10">
        
        <h2 class="text-2xl font-bold text-white flex items-center gap-3">
          <span class="bg-white/20 p-2 rounded-xl  ">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
            </svg>
          </span>
          Subir archivo .CSV libro mayor
        </h2>
        <div class="flex flex-wrap gap-3 mt-3">
          <div class="bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2 text-white/90 text-xs">
            <span class="font-semibold">Columnas:</span> "Cuenta","Fecha","Número","Tipo Comprobante","Descripción","Monto", "C.Negocio"
          </div>
          <div class="bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2 text-white/90 text-xs">
            <span class="font-semibold">Separador:</span> PUNTO Y COMA
          </div>
          <div class="bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2 text-white/90 text-xs">
            <span class="font-semibold">Última fila:</span> 'Totales' | Suma de montos
          </div>
        </div>
      </div>
    </div>

    <!-- Contenedor principal con efecto glass -->
    <div class="bg-white/80   rounded-2xl shadow-2xl border border-white/20 p-6 mb-6">
      <div v-if="showForm" class="space-y-6">
        <!-- Alerta de error -->
        <div v-if="error_monto_modificacion_ya_alcanzado" class=" overflow-hidden rounded-xl bg-red-50 border border-red-200 p-4">
          <div class="flex items-center gap-3">
            <span class="text-2xl">⚠️</span>
            <p class="text-red-600 text-sm font-medium">Error: monto ingresado excesivo</p>
          </div>
        </div>

        <!-- Card de formulario -->
        <div class="   overflow-hidden rounded-xl bg-gradient-to-br from-gray-50 to-white border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Columna 1: Glosa -->
            <div>
              <label class="block text-xs font-semibold text-gray-600 uppercase tracking-wider mb-2">
                📝 Glosa
              </label>
              <textarea
                v-model="glosa"
                placeholder="Ingrese una glosa para esta importación..."
                rows="3"
                class="w-full rounded-xl border border-gray-300 px-4 py-3 bg-white shadow-sm focus:ring-2 focus:ring-indigo-400 focus:border-transparent transition-all duration-200 outline-none resize-none"
                :class="glosa ? 'border-indigo-300' : 'border-gray-300'"
              ></textarea>
              <p class="text-xs text-gray-400 mt-1">{{ glosa ? glosa.length : 0 }} caracteres</p>
            </div>

            <!-- Columna 2: Upload -->
            <div>
              <label class="block text-xs font-semibold text-gray-600 uppercase tracking-wider mb-2">
                📂 Archivo CSV
              </label>
              
              <div class="relative">
                <label for="file-input" class="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-xl cursor-pointer transition-all duration-300 hover:bg-indigo-50/50"
                  :class="error_file ? 'border-red-400 bg-red-50/50' : 'border-gray-300 hover:border-indigo-400'">
                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg class="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                    <p class="mb-2 text-sm text-gray-500"><span class="font-semibold">Haz clic para subir</span> o arrastra y suelta</p>
                    <p class="text-xs text-gray-400">Archivos CSV (PUNTO Y COMA)</p>
                  </div>
                  <input
                    type="file"
                    name="file"
                    id="file-input"
                    :key="fileKey"
                    @change="onFileChange"
                    class="hidden"
                    accept=".csv"
                  />
                </label>
                
                <!-- Nombre del archivo seleccionado -->
                <div v-if="file_url" class="w-full mt-3 flex items-center gap-2 text-sm bg-indigo-50 rounded-lg px-4 py-2 border border-indigo-200">
                  <span class="text-indigo-600">📄</span>
                  <span class="text-gray-700 font-medium truncate flex-1">{{ file_url }}</span>
                  <button @click="limpiarArchivo" class="text-gray-400 hover:text-red-500 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <p v-if="error_file" class="w-full mt-2 text-red-500 text-xs flex items-center gap-1">
                  <span>❌</span> Debe subir archivo CSV adjunto
                </p>

                <!-- Barra de progreso -->
                <div v-if="uploading" class="w-full mt-4">
                  <div class="relative">
                    <div class="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
                      <div class="bg-gradient-to-r from-indigo-500 to-purple-500 h-2.5 transition-all duration-300 rounded-full" :style="{ width: uploadProgress + '%' }"></div>
                    </div>
                    <p class="text-xs text-gray-500 mt-2 flex items-center justify-between">
                      <span>{{ uploadProgressGlosa }}</span>
                      <span class="font-mono font-semibold text-indigo-600">{{ uploadProgress }}%</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estado de modificación grabada -->
      <div v-if="!showForm" class="text-center py-12">
        <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-4">
          <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h3 class="text-lg font-semibold text-gray-800">Modificación grabada</h3>
        <p class="text-sm text-gray-500">Los datos se han guardado correctamente</p>
      </div>

      <!-- Footer con botón de acción -->
      <div class="mt-6 pt-6 border-t border-gray-200 flex flex-wrap items-center justify-between gap-4">
        <div class="text-xs text-gray-500">
          <span class="font-mono">⚡</span> Archivo CSV con separador <span class="font-semibold">PUNTO Y COMA</span>
        </div>
        <div class="flex items-center gap-3">
          <button
            v-if="!loading"
            @click="uploadFile"
            class="relative overflow-hidden px-8 py-3 rounded-xl font-medium text-white transition-all duration-300 shadow-lg hover:shadow-xl active:scale-95"
            :class="enable_btn_grabar === false 
              ? 'bg-gray-300 cursor-not-allowed shadow-none' 
              : 'bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700'"
            :disabled="enable_btn_grabar === false"
          >
            <span class="relative z-10 flex items-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
              </svg>
              Importar archivo
            </span>
          </button>
          <div v-if="loading" class="flex items-center gap-3">
            <div class="w-8 h-8 border-4 border-gray-200 border-t-indigo-600 rounded-full animate-spin"></div>
            <span class="text-sm text-gray-600">Procesando...</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Resultado de importación -->
    <div v-if="importacion_completada" class="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-2xl border border-white/20 p-6 mt-6">
      <div class="flex items-center gap-3 mb-6">
        <span class="text-2xl">📊</span>
        <h3 class="text-xl font-bold text-gray-800">Resultado de la importación</h3>
      </div>

      <!-- Tarjetas de estadísticas -->
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div class="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <div class="flex items-center justify-between">
            <span class="text-sm text-gray-500">Registros leídos</span>
            <span class="text-2xl font-bold text-gray-700">{{ registros_leidos }}</span>
          </div>
        </div>
        <div class="bg-white rounded-xl p-4 shadow-sm border border-green-100 hover:shadow-md transition-shadow">
          <div class="flex items-center justify-between">
            <span class="text-sm text-green-600">Nuevos</span>
            <span class="text-2xl font-bold text-green-600">{{ registros_creados }}</span>
          </div>
        </div>
        <div class="bg-white rounded-xl p-4 shadow-sm border border-blue-100 hover:shadow-md transition-shadow">
          <div class="flex items-center justify-between">
            <span class="text-sm text-blue-600">Actualizados</span>
            <span class="text-2xl font-bold text-blue-600">{{ registros_actualizados }}</span>
          </div>
        </div>
        <div class="bg-white rounded-xl p-4 shadow-sm border border-red-100 hover:shadow-md transition-shadow">
          <div class="flex items-center justify-between">
            <span class="text-sm text-red-600">Erróneos</span>
            <span class="text-2xl font-bold" :class="registros_erroneos > 0 ? 'text-red-600' : 'text-gray-700'">
              {{ registros_erroneos }}
            </span>
          </div>
        </div>
      </div>

      <!-- Totales y estado -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white rounded-xl p-4 border border-gray-100">
          <p class="text-gray-500 text-xs uppercase tracking-wide mb-3">💰 Total gastos</p>
          <div class="grid grid-cols-2 gap-2 items-center">
            <span class="text-sm text-gray-600">Suma:</span>
            <span class="font-semibold text-right font-mono text-indigo-600">
              $ {{ $formatoMiles(suma_totales) }}
            </span>
            <span class="text-sm text-gray-600">Check Suma:</span>
            <span class="font-semibold text-right font-mono text-green-600">
              $ {{ $formatoMiles(checksum_totales) }}
            </span>
          </div>
        </div>

        <div class="bg-white rounded-xl p-4 border border-gray-100">
          <p class="text-gray-500 text-xs uppercase tracking-wide mb-3">📋 Estado</p>
          <div class="flex flex-wrap items-center gap-3">
            <span
              v-if="status_importacion"
              class="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium bg-green-100 text-green-700"
            >
              <span class="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
              ✔ Importación exitosa
            </span>
            <span
              v-else
              class="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium bg-red-100 text-red-700"
            >
              <span class="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
              ✖ Importación defectuosa
            </span>
            <a :href="apiUrl + '/logs/importlibromayor/'" target="_blank" 
               class="inline-flex items-center gap-2 px-4 py-2 bg-indigo-50 text-indigo-600 rounded-lg hover:bg-indigo-100 transition-colors text-sm">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Ver logs
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Mensaje de borrado exitoso -->
    <div v-if="status_eliminacion" class="mt-6">
      <div class="bg-gradient-to-r from-red-600 to-red-700 rounded-xl p-4 shadow-lg">
        <div class="flex items-center justify-center gap-3 text-white">
          <span class="text-2xl">🗑️</span>
          <span class="font-semibold">Borrado exitoso</span>
        </div>
      </div>
    </div>

    <!-- Tabla de detalles -->
    <div v-if="detalleslibro && detalleslibro.length > 0" class="mt-6 bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
      <!-- Encabezado de tabla -->
      <div class="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-white border-b border-gray-200">
        <div class="flex items-center gap-3">
          <span class="text-2xl">📋</span>
          <h4 class="font-semibold text-gray-800">Detalle de registros</h4>
          <span class="text-xs bg-indigo-100 text-indigo-600 px-2 py-1 rounded-full">{{ detalleslibro.length }} registros</span>
        </div>
        <button
          @click="borralibromayor()"
          v-if="libromayorgeneral_id"
          class="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all duration-300 shadow-md hover:shadow-lg active:scale-95"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 7h12M9 7V4h6v3m-7 4v6m4-6v6m4-10v10a2 2 0 01-2 2H8a2 2 0 01-2-2V7h12z" />
          </svg>
          Borrar este libro
        </button>
      </div>

      <!-- Scroll de tabla -->
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-gray-700" id="detalle">
          <thead class="bg-gradient-to-r from-gray-100 to-gray-50 sticky top-0">
            <tr class="text-gray-600">
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Fecha</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Centro</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Nombre Centro</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Cuenta</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Nombre cuenta</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Comprobante</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Número</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Descripción</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Débito</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Credito</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider">Total gasto</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(item, index) in detalleslibro"
              :key="item.indice"
              class="border-b hover:bg-indigo-50/50 transition-colors"
              :class="{ 'bg-gray-50/50': index % 2 !== 0 }"
            >
              <td class="px-2 py-2.5 text-sm text-center">{{ item.fecha }}</td>
              <td class="px-2 py-2.5 text-sm text-center font-medium">{{ item.centro }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ item.centro_nombre }}</td>
              <td class="px-2 py-2.5 text-sm text-center font-mono">{{ item.cuenta }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ item.cuenta_nombre }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ item.tipocomprobante }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ item.numero }}</td>
              <td class="px-2 py-2.5 text-sm text-center max-w-[150px] truncate" :title="item.descripcion">
                {{ item.descripcion }}
              </td>
              <td class="px-2 py-2.5 text-sm text-center font-mono">${{ $formatoMiles(item.debito) }}</td>
              <td class="px-2 py-2.5 text-sm text-center font-mono">${{ $formatoMiles(item.credito) }}</td>
              <td class="px-2 py-2.5 text-sm text-center font-mono font-semibold text-indigo-600">
                ${{ $formatoMiles(item.total_gastos) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/axios";

export default {
  name: "ModalIngresoMes",

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    centro_id: {
      type: Number,
    },
    nomcta: {
      type: String,
    },
    nomcentro: {
      type: String,
    },
    datosModificacion: {
      type: Object,
    },
    modificaciones_bloqueados: {
      type: Boolean,
    },
    timestamp: {
      type: String,
    },
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_DJANGO_API_URL;
    },
    mesTexto() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return this.mes > 0 ? meses[this.mes - 1] : "";
    },
  },
  watch: {
    timestamp: function () {
      this.recargaDatos(this.datosModificacion);
    },
  },
  methods: {
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
      console.log("Archivo seleccionado:", this.selectedFile);
    },
    async uploadFile() {
      if (!this.selectedFile) return;
      const formData = new FormData();
      
      formData.append("file", this.selectedFile);
      formData.append("glosa", this.glosa);
 

      this.importacion_completada = false;
      this.uploadProgress = 0;
      this.uploadProgressGlosa = "Subiendo archivo...";
      this.uploading = true;
      this.loading = true;
      try {
        const resp = await api.post("/api/v1/libromayor/upload/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.uploadProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            }
          },
        });
        this.error_file = false;

        if (resp.data.error) {
          alert(resp.data.error);
          this.error_file = true;
          this.uploadProgressGlosa = "";
          this.uploadProgress = 0;
          return;
        }

        this.detalleslibro = resp.data.detalle;
        this.libromayorgeneral_id = resp.data.libromayorgeneral_id;
        this.suma_debito = resp.data.suma_debito;
        this.suma_credito = resp.data.suma_credito;
        this.suma_totales = resp.data.suma_totales;
        this.checksum_debito = resp.data.checksum_debito;
        this.checksum_credito = resp.data.checksum_credito;
        this.checksum_totales = resp.data.checksum_totales;
        this.registros_leidos = resp.data.registros_leidos;
        this.registros_creados = resp.data.registros_creados;
        this.registros_actualizados = resp.data.registros_actualizados;
        this.registros_erroneos = resp.data.registros_erroneos;
        this.status_importacion = false;
       
        this.status_importacion = true;
        

        this.loading = false;
        1;
        this.file_url = resp.data.file_url;
        this.uploadProgressGlosa = resp.data.message;
        this.fileKey++;

        this.importacion_completada = true;
      } catch (error) {
        this.uploadProgressGlosa = "Error al subir archivo";
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.detail;
          console.error("Error al enviar:", error);
          console.log("Código:", status);
          console.log("Mensaje:", message);
        }
      }
    },
    async borralibromayor() {

      if (!confirm('¿Confirma que desea borrar este registro?')){
        return false;
      }

      this.uploadProgress = 0;
      const formData = new FormData();
      formData.append("libromayorgeneral_id", this.libromayorgeneral_id);
      try {
        const resp = await api.post("/api/v1/libromayor/delete/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (resp.data.error) {
          alert(resp.data.error);

          return;
        }

        this.loading = false;
        this.detalleslibro = [];
        this.libromayorgeneral_id = false;
        this.importacion_completada=false;
        this.status_eliminacion=true;
  

      } catch (error) {
        const status = error.response.status;
        const message = error.response.data?.detail;
        console.error("Error al enviar:", error);
        console.log("Código:", status);
        console.log("Mensaje:", message);
      }
    },
  },
  data() {
    return {
      glosa: "",
      presupuesto_id: 0,
      ingreso_id: 0,
      accion_id: 0,
      mes: 0,
      file_url: "",

      meses: [
        "Ene.",
        "Feb.",
        "Mar.",
        "Abr.",
        "May.",
        "Jun.",
        "Jul.",
        "Ago.",
        "Sept.",
        "Oct.",
        "Nov.",
        "Dic.",
      ],
      monto_mensual: "",
      array_monto_mensual: new Array(13).fill(0),
      marca_modificacion: new Array(13),
      cuentaSelec: 0,
      centroSelec: 0,

      objMesYMonto: {},
      mesSelec: 0,

      reasignar_isOn: false,
      accion: "Disminución",
      error_props: false,
      error_monto: false,
      error_file: false,
      error_cuenta: false,
      error_centro: false,
      error_selecciona_cuenta: false,
      error_saldo_insuficiente: false,
      error_falta_selec_mes: false,
      error_ingresos_insuficientes: false,
      error_monto_modificacion_ya_alcanzado: false,
      error_faltan_movimientos: false,
      fileKey: 0,
      enable_btn_grabar: true,
      puede_restar: false,
      puede_sumar: false,
      puede_mostrar_meses: false,
      porcentaje_movimientos: 0,
      list_total_movimientos: [],
      list_movimientos: [],

      total_movimientos: 0,

      showForm: true,

      uploadProgress: 0,
      uploading: false,
      uploadProgressGlosa: "",
      selectedFile: "",
      detalleslibro: [],
      libromayorgeneral_id: false,
      loading: false,

      suma_debito: 0,
      suma_credito: 0,
      checksum_debito: 0,
      checksum_credito: 0,
      status_importacion: "",
      registros_leidos: 0,
      registros_creados: 0,
      registros_actualizados: 0,
      registros_erroneos: 0,
      importacion_completada: false,
      status_eliminacion:false
    };
    /**
     * list_movimientos
     * 
     [{
        "indice":0,
        "centro":37,
        "centro_datos":"VCO069000000000 - Amigos del Parque Pumalin",
        "cuenta":32,
        "cuenta_datos":"4.5.1030.40.15 - Alimentación animales de trabajo",
        "objMesMonto":{
          "mes":5,
          "monto":4
        }
     }]
     */
  },
  mounted() {
    this.enable_btn_grabar = true;

    this.file_url = "";
  },
};
</script>

<style scoped></style>
